export default "__VITE_ASSET__ChNpoFD$__"